import { Box, Skeleton } from "@mui/material";

import { styles } from "./styles";

export const ServiceSummaryLoader = () => {
  return (
    <Box sx={styles.container}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <Skeleton variant="rounded" width={200} height={40} />
        <Skeleton variant="rounded" width={150} height={24} />
      </Box>
      <Skeleton variant="rounded" width="100%" height={1} />
      <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <Box sx={styles.serviceDetailsContainer}>
          <Box sx={styles.serviceDetailsTitle}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="rounded" width="100px" height={24} />
          </Box>
          <Skeleton variant="rounded" width="40px" height={20} />
        </Box>
        <Box sx={styles.serviceDetailsContainer}>
          <Box sx={styles.serviceDetailsTitle}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="rounded" width="100px" height={20} />
          </Box>
          <Skeleton variant="rounded" width="40px" height={20} />
        </Box>
        <Box sx={styles.serviceDetailsContainer}>
          <Box sx={styles.serviceDetailsTitle}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="rounded" width="100px" height={20} />
          </Box>
          <Skeleton variant="rounded" width="40px" height={20} />
        </Box>
        <Box sx={styles.serviceDetailsContainer}>
          <Box sx={styles.serviceDetailsTitle}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="rounded" width="100px" height={20} />
          </Box>
          <Skeleton variant="rounded" width="40px" height={20} />
        </Box>
        <Box sx={styles.serviceDetailsContainer}>
          <Box sx={styles.serviceDetailsTitle}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="rounded" width="100px" height={20} />
          </Box>
          <Skeleton variant="rounded" width="40px" height={20} />
        </Box>
      </Box>
      <Skeleton variant="rounded" width="100%" height={1} />
      <Box sx={{ display: "flex", gap: "16px", alignItems: "center" }}>
        <Skeleton variant="circular" width={44} height={44} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", flex: 1 }}>
          <Skeleton variant="rounded" width={150} height={24} />
          <Skeleton variant="rounded" width={100} height={18} />
        </Box>
      </Box>
      <Skeleton variant="rounded" width="100%" height={1} />
      <Skeleton variant="rounded" width="100%" height={40} />
      <Skeleton variant="rounded" width="100%" height={1} />
      <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <Skeleton variant="rounded" width={150} height={24} />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          {[...Array(5)].map((_, index) => (
            <Skeleton key={index} variant="rounded" width={35} height={35} sx={{ borderRadius: "6px" }} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
